import { Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { ReactNode } from 'react';

const SlideUpTransition = React.forwardRef(function SlideUpTransition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface ProcessDialogRootProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const ProcessDialogRoot: React.FC<ProcessDialogRootProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={SlideUpTransition}
    >
      {children}
    </Dialog>
  );
};

export default ProcessDialogRoot;
